import _ from 'lodash'
const initialState = {
  master:{ "categories": [], "centers": [],   "clients": [],   "processes": [], "regions": []}
}
export default (state = initialState, action) => {
  let newmaster = _.cloneDeep(state.master)
  switch (action.type) {
    case "INVENTORY_ACTION":
      return Object.assign({}, state, {
      result: action.payload,
      isPending: action.isPending
    })
    case "INVENTORY_PENDING":
      return Object.assign({}, state, {
        isPending: action.isPending
    })
    case "INVENTORY_ACTION_MASTER":
        return Object.assign({}, state, {
          master: action.payload,
          isPending: action.isPending
    })
    case "INVENTORY_ACTION_MASTER_ADD":  
         newmaster[action.prop].push(...action.object)
        return Object.assign({}, state, {
         master: newmaster,
         isPending:action.isPending
    }) 
    case "INVENTORY_ACTION_MASTER_UPDATE":        
        let obj = newmaster[action.object] 
        obj[action.index].label = action.prop; 
        return Object.assign({}, state, {
         master: newmaster,
         isPending: action.isPending
    })  
    case "INVENTORY_ACTION_MASTER_EDIT": 
      let x = _.find(newmaster[action.object], action.prop)
      x.status = action.StatusOBj
      return Object.assign({}, state, {
      master: newmaster,
      isPending: action.isPending
    })
    case "CLIENT_MANAGEMENT_PENDING":
      return Object.assign({}, state, {
        isPending:action.isPending
    })
    case "CLIENT_MANAGEMENT_SUCCESS":
      return Object.assign({}, state, {        
      clients: action.payload,
      isPending:action.isPending
    })
    case "CLIENT_MANAGEMENT_ERROR":
      return Object.assign({}, state, {
      error: action.error
    })  

    case "INVENTORY_CATEGORIES" :
      return Object.assign({}, state, {
        categories: action.payload
    }) 
    case "REPORTS_MASTER" :
      let reportlist = _.filter(action.list, function(o) { return !_.isEmpty(o.reportName) });
      return Object.assign({}, state, {
        reportList: reportlist
    })
    case "FREQUENCY_MASTER":
      return Object.assign({}, state, {
        freqList: action.freqlist
    })
    case "INVENTORY_MODAL_CLOSE":
      return Object.assign({}, state, {
       showerror: action.showerror
    })
    case "INVENTORY_ERROR":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPending: action.isPending
    })
    default:
    return state
  }
 }